import React, { useContext, useState } from 'react';
import { useRecommendedKeywords } from 'hooks';

export interface PopularKeywordState {
  terms: string[];
  setStartCallApi: (val: boolean) => any;
}

export interface PopularKeywordProviderProps {
  children: React.ReactNode;
}

const initialState: PopularKeywordState = {
  terms: [],
  setStartCallApi: () => {},
};

const PopularKeywordStateContext =
  React.createContext<PopularKeywordState>(initialState);

export const PopularKeywordProvider: React.FunctionComponent<
  PopularKeywordProviderProps
> = ({ children }: PopularKeywordProviderProps) => {
  const [startCallApi, setStartCallApi] = useState(false);
  const { result } = useRecommendedKeywords(startCallApi);
  return (
    <PopularKeywordStateContext.Provider
      value={{
        terms: result,
        setStartCallApi,
      }}
    >
      {children}
    </PopularKeywordStateContext.Provider>
  );
};

export function usePopularKeyword(): PopularKeywordState {
  const context = useContext(PopularKeywordStateContext);
  if (!context) {
    throw new Error(
      'usePopularKeyword must be inside a PopularKeywordStateContext with a state value',
    );
  }
  return context;
}
